import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M 4.296875,6 C 3.0312585,6 2,7.0116033 2,8.234375 v 7.53125 C 2,16.988399 3.0312965,18 4.296875,18 h 9.582031 c 1.265603,0 2.296875,-1.011634 2.296875,-2.234375 V 8.234375 C 16.175781,7.0116972 15.13444,6 13.878906,6 Z m 16.802736,1.2890626 h -0.002 l -3.773484,2.1074156 v 5.1835938 c 1.307147,0.722789 2.451495,1.334058 3.763403,1.994088 C 22.099043,17.101256 23,16.45058 23,15.429688 V 8.5253906 c 0,-0.9450808 -0.803156,-1.824727 -1.900389,-1.236328 z" />,
  'FilmCamera'
);
